var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1700 725",
    style: {
      enableBackground: "new 0 0 1700 725"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF884D;}\n\t.st1{fill:#485BE4;}\n\t.st2{fill:#05ADE9;}\n\t.st3{fill:#A6AEF1;}\n\t.st4{fill:#7985EA;}\n\t.st5{fill:#FCA821;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.5,725h-53.9v-67.5H54.4V725H0V549.9h54.4v62h104.1v-62h53.9V725z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.6,725h-54.2V549.9h54.2V725z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M386.2,680c41.3,0,55-9.4,55-34.5v-95.5h54.4v95.5c0,53.1-36.6,79.6-109.4,79.6h-65.4l35.3-45H386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M579.3,725l32.7-45h44c10.5,0,22.8,0,31.1,0.5c-4.7-6.3-12-17-17.8-25.4l-31.4-46.3L555.8,725h-64.1 l112.3-158.3c7.3-10.2,18.1-19.6,35.1-19.6c16.2,0,27,8.6,34.5,19.6L782.9,725H579.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M998,680l-34.8,45h-87.9c-60.7,0-105.5-38.5-105.5-89.2c0-51.3,44.7-85.8,105.5-85.8H998l-34.8,45.5h-87.9 c-29.3,0-51.3,17.5-51.3,42.7c0,24.9,21.7,41.9,51.3,41.9H998z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1237.7,725h-81.9l-52.9-46.1c-18.1-15.7-26.4-23.3-32.4-29.3c0.3,8.1,0.8,16.7,0.8,25.1V725h-54.4V549.9 h54.4v40.6c0,10.7-0.5,21.5-1,30.6c6.8-6.3,16.2-15.2,32.2-28.5l50.5-42.7h78.5l-67,50.2c-23.3,17.5-34,25.4-45.3,32.2 c9.9,6.8,23.6,16.5,46.1,34.8L1237.7,725z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1458.8,680l-34.8,45h-168.5V549.9h202.8l-35.1,45.5h-113.3v20.9h138.7l-31.1,39.8h-107.6V680H1458.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1594.5,725h-117.2V615.9h54.4V680h62.8c30.1,0,51.8-16.7,51.8-41.9c0-24.6-22.5-42.7-51.8-42.7h-117.2 l34.5-45.5h82.7c61.2,0,105.5,35.3,105.5,85.8C1700,686.5,1655.3,725,1594.5,725z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 675,
    y: 150,
    className: "st1",
    width: 350,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1140,470H560c-5.5,0-10-4.5-10-10l0,0c0-5.5,4.5-10,10-10h580c5.5,0,10,4.5,10,10l0,0 C1150,465.5,1145.5,470,1140,470z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M990,185H710c-5.5,0-10-4.5-10-10v0c0-5.5,4.5-10,10-10h280c5.5,0,10,4.5,10,10v0 C1000,180.5,995.5,185,990,185z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M850,150H700V83.5c0-4.9,3.5-9.1,8.4-9.9L850,50V150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M850,150h150V83.5c0-4.9-3.5-9.1-8.4-9.9L850,50V150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1064.8,247.8l-215-47.8l-215,47.8c-5.5,1.2-8.9,6.7-7.5,12.2l47.5,190h175h175l47.5-190 C1073.7,254.5,1070.3,249,1064.8,247.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M845.8,200.9L635,247.8c-5.5,1.2-8.9,6.7-7.5,12.2l9.2,36.8L771,258.5c5.3-1.5,10.8,1.6,12.4,6.9v0 c1.5,5.3-1.6,10.8-6.9,12.4l-134.6,38.4l-2.5-8.7L675,450h165V210C840,206,842.4,202.5,845.8,200.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1065,247.8l-210.8-46.8c3.4,1.6,5.8,5,5.8,9.1v240h165l34.3-137l-135.7-34.1c-5.4-1.3-8.6-6.8-7.3-12.1 s6.8-8.6,12.1-7.3l135.7,34.1l8.4-33.6C1073.9,254.5,1070.5,249,1065,247.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1090,100.5H875V35V10c0-5.5-4.5-10-10-10h-30c-5.5,0-10,4.5-10,10v25v65.5H610c-5.5,0-10,4.5-10,10v30 c0,5.5,4.5,10,10,10h480c5.5,0,10-4.5,10-10v-30C1100,105,1095.5,100.5,1090,100.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.467b6dac14365ad116a0935493facba7.svg";
export { ForwardRef as ReactComponent };